import React, { useEffect, useState } from 'react';
import { apiClient } from '../../../utils/axios';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from '@mui/material';

const BulkUploadTemplateSelector = ({ onSelect }) => {
  const [templates, setTemplates] = useState([]);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    apiClient.get('/bulk-uploads/template').then((response) => {
      setTemplates(response.data.template_configs);
    });
  }, []);

  useEffect(() => {
    setTemplateOptions(
      templates.map((item) => {
        return { key: item.template_name, value: item.template_name, label: item.display_name };
      }),
    );
  }, [templates]);

  const onChange = (event, value) => {
    console.log(value);
    setSelectedTemplate(value);
    onSelect(value?.value);
  };

  return (
    <Autocomplete
      id="template-selector"
      options={templateOptions}
      renderInput={(params) => <TextField {...params} label={'Template Name'} />}
      onChange={onChange}
      value={selectedTemplate || null}
    ></Autocomplete>
  );
};

export default BulkUploadTemplateSelector;
